import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useDerivedMetricsV2({
  branchIds,
  start,
  end,
  tipo,
  groupBy = "none",
  compare,
  enabled = true,
}) {
  const { getDerivedMetrics } = useApiV2();
  const { user } = useAuth();

  return useQuery({
    queryKey: [
      "derivedMetricsV2",
      user?.user_id ?? null,
      branchIds,
      start,
      end,
      tipo,
      groupBy,
      compare ?? null,
    ],
    queryFn: () =>
      getDerivedMetrics({
        branch_id: branchIds,
        start,
        end,
        tipo,
        group_by: groupBy,
        ...(compare ? { compare } : {}),
      }),
    enabled: Boolean(enabled && branchIds?.length && start && end && tipo),
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
